export function masterItemParser(item) {
  let record = {
    id: item.id,
    title: item.locale_title,
    locale_title: item.locale_title,
    icon: item.icon,
  };
  return record
}
